import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faFacebook,
  faLinkedin,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";

library.add(faFacebook, faLinkedin, faTwitter);



// WEBPACK FOOTER //
// ./src/fontawesome/brands.js